export default "__VITE_ASSET__572e8f74__"